// libs/utils.ts

export const getJwtToken = (): string | undefined =>
  typeof window === "object" ? localStorage.getItem("o_a") || "" : undefined;
